// Order management utilities for price parts
// Extracted from apps/web/src/components/common/order-util.ts

const getNextOrder = (items: { order: number }[]) => {
  if (!items || items.length == 0) {
    return 0;
  }

  let max = -1;
  for (const p of items) {
    if (p.order === undefined || p.order === null) {
      continue;
    }
    max = Math.max(max, p.order);
  }

  return max + 1;
};

const sortByOrder = (items: { order: number }[]) => {
  return items.sort((a, b) => a.order - b.order);
};

const liftItemUp = (items: { order: number }[] = [], liftedIndex: number) => {
  if (liftedIndex <= 0 || items.length < 2) {
    return;
  }

  __upOrder(liftedIndex - 1, liftedIndex, items);
};

const liftItemDown = (items: { order: number }[] = [], liftedIndex: number) => {
  if (items.length < 2 || liftedIndex >= items.length - 1) {
    return;
  }

  __upOrder(liftedIndex, liftedIndex + 1, items);
};

const __upOrder = (
  index: number,
  uppingIndex: number,
  allItems: { order: number }[]
) => {
  const item = allItems[index];
  const uppingItem = allItems[uppingIndex];

  if (item.order < uppingItem.order) {
    [item.order, uppingItem.order] = [uppingItem.order, item.order];
  } else if (item.order == uppingItem.order) {
    item.order += 1;
    let nextOrder = item.order;
    const items = allItems;
    for (let i = index; i < items.length; ++i) {
      if (items[i].order < nextOrder) {
        items[i].order = nextOrder = nextOrder + 1;
      }
    }
  }
};

const normalizeOrder = (items: { order: number }[]) => {
  items = sortByOrder(items);
  let order = 0;
  for (const it of items) {
    it.order = order++;
  }

  return items;
};

export { getNextOrder, sortByOrder, liftItemUp, liftItemDown, normalizeOrder };
